<template>
  <layout-content>
    <tooltip
      v-if="$route.params.type === 'webhook'"
      slot="top-buttons"
      :content="$t('autocaller_v2.webhook.button.disabled')"
      :disabled="!disabled"
      theme="light"
    >
      <i-button type="primary" size="large" :disabled="disabled" @click="create_webhook">
        {{ $t('autocaller_v2.webhook.button.create') }}
      </i-button>
    </tooltip>

    <i-button
      v-if="$route.params.type === 'products'"
      slot="top-buttons"
      type="primary"
      size="large"
      @click="create_product"
    >
      {{ $t('autocaller_v2.operators.skills.create') }}
    </i-button>

    <tabs
      type="card"
      :animated="false"
      :value="$route.params.type"
      @on-click="$router.push({ to: 'autocaller_v2.settings.type', params: { type: $event } })"
    >
      <tab-pane
        v-for="tab in ['webhook', 'products']"
        :key="tab"
        :name="tab"
        :label="$t(`autocaller_v2.breadcrumb.${tab}.index`)"
      />
    </tabs>

    <component :is="`page-${$route.params.type}`" />
  </layout-content>
</template>

<script>
  import TableComponent from '@autocaller_v2/components/webhook-table.vue';
  import { WebhookModalService } from '@autocaller_v2/modals/WebhookModalService';
  import { ProductsModalService } from '@autocaller_v2/modals/ProductsModalService';
  import { mapActions, mapGetters } from 'vuex';
  import { TOTAL_ITEMS } from '@app/plugins/vuex-async-pagginate';
  export default {
    components: {
      'page-webhook': () => import('@autocaller_v2/pages/webhook-list-page'),
      'page-products': () => import('@autocaller_v2/pages/products-list-page')
    },

    computed: {
      ...mapGetters('autocaller_v2/webhook/table', { total_items: TOTAL_ITEMS }),
      disabled() {
        return this.total_items == 16;
      }
    },
    methods: {
      ...mapActions('autocaller_v2/webhook/table', ['getAsyncData']),
      ...mapActions('autocaller_v2/products/table', {
        getProductsAsyncData: 'getAsyncData'
      }),

      create_webhook: function () {
        WebhookModalService.create().on('success', () => this.getAsyncData());
      },
      create_product: function () {
        ProductsModalService.create().on('success', () => {
          return this.getProductsAsyncData({ current_page: 1 });
        });
      }
    }
  };
</script>
